import React from "react";
import Dev from "../../components/Dev/Dev";
import {
  DevDataObjKartik,
  DevDataObjVishwanath,
} from "../../components/Dev/DevData";
import "./Devs.css";

const Devs = () => {
  return (
    <div className="section__padding devsContainer ">
      <div className="devs-heading">
        <h1 className="gradient__text">Our Team</h1>
      </div>
      <div className="container  devsCard">
        <Dev {...DevDataObjKartik} />
      </div>
      <div className="container  devsCard">
        <Dev {...DevDataObjVishwanath} />
      </div>
    </div>
  );
};

export default Devs;
